import { handleActions } from 'redux-actions';
import * as types from './types';

const initialState = {
  data: {},
  error: null,
  initialLoad: false,
  loading: false,
  saving: false,
};

const createTimesheetRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const createTimesheetRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const createTimesheetRequestSuccess = (state) => ({
  ...state,
  error: null,
  saving: false,
});

const deleteTimesheetRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const deleteTimesheetRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const deleteTimesheetRequestSuccess = (state) => ({
  ...state,
  error: null,
  saving: false,
});

const duplicateTimesheetRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const duplicateTimesheetRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const duplicateTimesheetRequestSuccess = (state) => ({
  ...state,
  error: null,
  saving: false,
});

const getTimesheetRequest = (state) => ({
  ...state,
  error: null,
  loading: true,
});
const getTimesheetRequestFailure = (state, action) => ({
  ...state,
  data: {},
  error: action.error,
  loading: false,
});
const getTimesheetRequestSuccess = (state, payload) => ({
  ...state,
  data: payload.data,
  error: null,
  initialLoad: true,
  loading: false,
});

const recallTimesheetRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const recallTimesheetRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const recallTimesheetRequestSuccess = (state, payload) => ({
  ...state,
  data: { ...payload.data.timesheet, entries: payload.data.entries },
  error: null,
  saving: false,
});

const resetTimesheetState = () => initialState;

const saveTimesheetAsyncRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const saveTimesheetRequestAsyncFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const saveTimesheetRequestAsyncSuccess = (state) => ({
  ...state,
  error: null,
  saving: false,
});

const submitTimesheetRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const submitTimesheetRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const submitTimesheetRequestSuccess = (state) => ({
  ...state,
  error: null,
  saving: false,
});

const submitTimesheetRequestAsync = (state) => ({
  ...state,
  error: null,
  saving: true,
});

const submitTimesheetRequestAsyncFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});

const submitTimesheetRequestAsyncSuccess = (state) => ({
  ...state,
  error: null,
  saving: false,
});

const updateTimesheetRequest = (state) => ({
  ...state,
  error: null,
  saving: true,
});
const updateTimesheetRequestFailure = (state, action) => ({
  ...state,
  error: action.error,
  saving: false,
});
const updateTimesheetRequestSuccess = (state) => ({
  ...state,
  error: null,
  saving: false,
});

export default handleActions(
  {
    [types.CREATE_TIMESHEET_REQUEST]: createTimesheetRequest,
    [types.CREATE_TIMESHEET_REQUEST_FAILURE]: createTimesheetRequestFailure,
    [types.CREATE_TIMESHEET_REQUEST_SUCCESS]: createTimesheetRequestSuccess,
    [types.DELETE_TIMESHEET_REQUEST]: deleteTimesheetRequest,
    [types.DELETE_TIMESHEET_REQUEST_FAILURE]: deleteTimesheetRequestFailure,
    [types.DELETE_TIMESHEET_REQUEST_SUCCESS]: deleteTimesheetRequestSuccess,
    [types.DUPLICATE_TIMESHEET_REQUEST]: duplicateTimesheetRequest,
    [types.DUPLICATE_TIMESHEET_REQUEST_FAILURE]: duplicateTimesheetRequestFailure,
    [types.DUPLICATE_TIMESHEET_REQUEST_SUCCESS]: duplicateTimesheetRequestSuccess,
    [types.GET_TIMESHEET_REQUEST]: getTimesheetRequest,
    [types.GET_TIMESHEET_REQUEST_FAILURE]: getTimesheetRequestFailure,
    [types.GET_TIMESHEET_REQUEST_SUCCESS]: getTimesheetRequestSuccess,
    [types.RECALL_TIMESHEET_REQUEST]: recallTimesheetRequest,
    [types.RECALL_TIMESHEET_REQUEST_FAILURE]: recallTimesheetRequestFailure,
    [types.RECALL_TIMESHEET_REQUEST_SUCCESS]: recallTimesheetRequestSuccess,
    [types.RESET_TIMESHEET_STATE]: resetTimesheetState,
    [types.SUBMIT_TIMESHEET_REQUEST]: submitTimesheetRequest,
    [types.SUBMIT_TIMESHEET_REQUEST_FAILURE]: submitTimesheetRequestFailure,
    [types.SUBMIT_TIMESHEET_REQUEST_SUCCESS]: submitTimesheetRequestSuccess,
    [types.SUBMIT_TIMESHEET_REQUEST_ASYNC]: submitTimesheetRequestAsync,
    [types.SUBMIT_TIMESHEET_REQUEST_ASYNC_FAILURE]: submitTimesheetRequestAsyncFailure,
    [types.SUBMIT_TIMESHEET_REQUEST_ASYNC_SUCCESS]: submitTimesheetRequestAsyncSuccess,
    [types.UPDATE_TIMESHEET_REQUEST]: updateTimesheetRequest,
    [types.UPDATE_TIMESHEET_REQUEST_FAILURE]: updateTimesheetRequestFailure,
    [types.UPDATE_TIMESHEET_REQUEST_SUCCESS]: updateTimesheetRequestSuccess,
    [types.SAVE_TIMESHEET_REQUEST_ASYNC]: saveTimesheetAsyncRequest,
    [types.SAVE_TIMESHEET_REQUEST_ASYNC_FAILURE]: saveTimesheetRequestAsyncFailure,
    [types.SAVE_TIMESHEET_REQUEST_ASYNC_SUCCESS]: saveTimesheetRequestAsyncSuccess,
  },
  initialState
);
